export const toBase64 = (file: File): Promise<string | ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * 1024;

/**
 * Formats byte size for display (e.g. "11.3 MB").
 */
export function formatFileSize(bytes: number): string {
  if (bytes < BYTES_PER_KB) return `${bytes} B`;
  if (bytes < BYTES_PER_MB) {
    const kb = bytes / BYTES_PER_KB;
    return `${kb % 1 === 0 ? kb : kb.toFixed(1)} KB`;
  }
  const mb = bytes / BYTES_PER_MB;
  return `${mb % 1 === 0 ? mb : mb.toFixed(1)} MB`;
}
